import Icon from 'molecules/Icon';

import type { ComponentPropsWithoutRef, FC } from 'react';

interface PlayButtonProps {
  /** Click handler passed from the parent */
  onClick: ComponentPropsWithoutRef<'button'>['onClick'];
  /** Accessible name for screen readers (defaults to “Play video”) */
  ariaLabel?: string;
  /** Optional title tooltip; falls back to ariaLabel */
  title?: string;
}

const PlayButton: FC<PlayButtonProps> = ({ onClick, ariaLabel = 'Play video', title }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    title={title ?? ariaLabel}
    className="flex items-center justify-center rounded-full bg-primary-button-default p-5 text-gray-900 shadow-2xl transition-colors duration-200 focus-outline-primary hover:bg-primary-button-hover sm:p-7 sm:shadow-2xl"
  >
    <Icon
      icon="play"
      size={30}
      className="relative left-[3px] size-5 sm:left-1 sm:size-full"
      aria-hidden="true"
      focusable="false"
    />
  </button>
);

export default PlayButton;
